import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClarificationNeededStatusIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white",
			style: { mixBlendMode: "multiply" }
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 8,
			r: 7.5,
			fill: "#D97F00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 6.24962C6.00007 5.88297 6.10093 5.5234 6.29155 5.2102C6.48217 4.897 6.75522 4.64222 7.08085 4.47372C7.40649 4.30522 7.77218 4.22947 8.13795 4.25476C8.50372 4.28005 8.85551 4.4054 9.15486 4.61712C9.4542 4.82883 9.68959 5.11876 9.83529 5.45521C9.981 5.79166 10.0314 6.1617 9.98102 6.52487C9.93063 6.88803 9.78138 7.23036 9.54958 7.51444C9.31778 7.79851 9.01235 8.0134 8.66667 8.13562C8.47161 8.20458 8.30275 8.33234 8.18335 8.50129C8.06395 8.67024 7.99989 8.87207 8 9.07895",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.99922 11.5C7.93988 11.5 7.88188 11.5176 7.83255 11.5506C7.78321 11.5835 7.74476 11.6304 7.72205 11.6852C7.69935 11.74 7.69341 11.8003 7.70498 11.8585C7.71656 11.9167 7.74513 11.9702 7.78709 12.0121C7.82904 12.0541 7.8825 12.0827 7.94069 12.0942C7.99889 12.1058 8.05921 12.0999 8.11402 12.0772C8.16884 12.0545 8.21569 12.016 8.24866 11.9667C8.28162 11.9173 8.29922 11.8593 8.29922 11.8C8.29922 11.7204 8.26761 11.6441 8.21135 11.5879C8.15509 11.5316 8.07878 11.5 7.99922 11.5Z",
			fill: "white",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgClarificationNeededStatusIcon);
export default ForwardRef;
